var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomheater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2502 3.75H3.75C3.33578 3.75 3 4.08582 3 4.50003V18.0002C3 18.4144 3.33578 18.7502 3.75 18.7502H4.49999V19.5002C4.49999 19.9144 4.83578 20.2502 5.24999 20.2502C5.66421 20.2502 5.99999 19.9144 5.99999 19.5002V18.7502H18.0001V19.5002C18.0001 19.9144 18.3359 20.2502 18.7501 20.2502C19.1643 20.2502 19.5001 19.9144 19.5001 19.5002V18.7502H20.2501C20.6643 18.7502 21.0001 18.4144 21.0001 18.0002V4.50003C21.0002 4.08582 20.6644 3.75 20.2502 3.75ZM19.5002 17.2502H4.50003V5.25003H19.5002V17.2502H19.5002Z",
    fill: "#B05A1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15C17.664 15 18 14.664 18 14.25C18 13.836 17.664 13.5 17.25 13.5C16.836 13.5 16.5 13.836 16.5 14.25C16.5 14.664 16.836 15 17.25 15Z",
    fill: "#B05A1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.74975C17.664 9.74975 18 9.41376 18 8.99975C18 8.58575 17.664 8.24976 17.25 8.24976C16.836 8.24976 16.5 8.58575 16.5 8.99975C16.5 9.41376 16.836 9.74975 17.25 9.74975Z",
    fill: "#B05A1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5001H15.0001C15.4143 16.5001 15.7501 16.1643 15.7501 15.7501V6.75C15.7501 6.33578 15.4143 6 15.0001 6H6C5.58578 5.99996 5.25 6.33578 5.25 6.75V15.7501C5.25 16.1643 5.58578 16.5001 6 16.5001ZM6.75003 12.0001H8.25006V15.0001H6.75003V12.0001ZM11.2501 12.0001V15.0001H9.75005V12.0001H11.2501ZM9.75005 10.5V7.49999H11.2501V10.5H9.75005ZM12.7501 15.0001V12.0001H14.2501V15.0001H12.7501ZM14.2501 10.5H12.7501V7.49999H14.2501V10.5ZM8.25002 7.49999V10.5H6.74999V7.49999H8.25002Z",
    fill: "#B05A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomheater);
export default __webpack_public_path__ + "static/media/roomheater.5c8f6293403461a5597e9f5743c77d56.svg";
export { ForwardRef as ReactComponent };